var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyzeIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Analyzing",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxWidth: "100%",
      maxHeight: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H34",
    stroke: "#1A75FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0,0,20.05723274589918,11.942767254100819"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: "indefinite",
    dur: "2.337651470855166s",
    values: "0,0,20.05723274589918,11.942767254100819;            0,11.942767254100819,20.05723274589918,0;            20.05723274589918,11.942767254100819,0,0",
    keyTimes: "0; 0.3732114766906506; 1",
    begin: "0.7615266774849407s"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H34",
    stroke: "#1A75FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0,0,17.991371185779048,14.008628814220952"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: "indefinite",
    dur: "2.425068158989653s",
    values: "0,0,17.991371185779048,14.008628814220952;            0,14.008628814220952,17.991371185779048,0;            17.991371185779048,14.008628814220952,0,0",
    keyTimes: "0; 0.43776965044440475; 1",
    begin: "0.22197574987463478s"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 30H34",
    stroke: "#1A75FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0,0,21.17452776307363,10.82547223692637"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: "indefinite",
    dur: "2.3021223507656243s",
    values: "0,0,21.17452776307363,10.82547223692637;            0,10.82547223692637,21.17452776307363,0;            21.17452776307363,10.82547223692637,0,0",
    keyTimes: "0; 0.33829600740394905; 1",
    begin: "0.8110349114910673s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzeIcon1);
export default __webpack_public_path__ + "static/media/analyze-icon1.2506a98750a6263ed59965e2dfeb404f.svg";
export { ForwardRef as ReactComponent };